import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, Grid2 as Grid } from "@mui/material";
import React from "react";
import { useToggle } from "../../../../hooks/useToggle";
import { CustomerModel } from "@attelas/shared";
import { EditCustomerInfoButton } from "./EditCustomerInfoButton";

type Props = {
  customerDetails: CustomerModel;
};

export function Description({ customerDetails }: Props) {
  const [open, openDialog, closeDialog] = useToggle(false);
  const description = customerDetails.description;
  const hasDescription = !!description;

  const renderContent = () => (
    <>
      <Typography
        sx={{
          maxWidth: "100px",
          wordBreak: "break-word",
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: "2",
          WebkitBoxOrient: "vertical",
          cursor: hasDescription ? "pointer" : "default",
        }}
        onClick={hasDescription ? openDialog : undefined}
      >
        {description && description.length > 15 ? `${description.slice(0, 20)}...` : description || "N/A"}
      </Typography>
      <Dialog open={open} onClose={closeDialog} fullScreen={true}>
        <DialogTitle>
          <Typography variant="h6" fontSize="18px">
            Description
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ whiteSpace: "pre-wrap" }}>{description}</Typography>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={closeDialog}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );

  return (
    <Grid container={true} alignItems="center" justifyContent="end" flexWrap="nowrap">
      <Grid mr={0.5}>{renderContent()}</Grid>
      <EditCustomerInfoButton customer={customerDetails} />
    </Grid>
  );
}
